import Phone from '../../src/legacy/Phone';
export default Phone;
